import React, { Component } from 'react';
// date time components
import { TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { zhCN } from 'date-fns/locale';
// Material components
import { InputAdornment,Chip, FormControl, InputLabel, Select, MenuItem, Typography, Divider, Grid, Box, IconButton, TextField, withStyles, Tooltip } from '@material-ui/core';

// Material icons
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutline from '@material-ui/icons/RemoveCircleOutline';
// Externals
import PropTypes from 'prop-types';
// Component styles
import styles from './styles';
// Form validation schema
const kqmode=[{id:0, name:'当天固定班次考勤', desp:'当天范围内，最多设置3个考勤时段，每个时段设置开始签到时间、上班考勤时间、下班考勤时间。多个时段之间的时间设置不能重叠。', desp2:'开始签到时间未到不能签到，到了开始签到时间可以签到，上班考勤时间之后签到为迟到，下班考勤时间之前签退为早退。'},
    {id:1, name:'跨天固定班次考勤', desp:'24小时范围内，最多设置3个考勤时段，每个时段设置开始签到时间、上班考勤时间、下班考勤时间、结束签到时间，时段之间不能重叠，可以跨天设置时间，考勤时段的时间跨度在24小时内。', desp2:'开始签到时间未到不能签到，到了开始签到时间可以签到，上班考勤时间之后签到为迟到，下班考勤时间之前签退为早退，结束签到时间之前可以签退，结束签到时间之后不能签退'},
    {id:2, name:'固定班次弹性考勤', desp:'24小时范围内，最多设置1个弹性考勤时段，需设置开始签到时间、上班考勤时间、上班弹性延迟时长、下班考勤时间、结束签到时间，可以跨天设置时间，时间跨度在24小时内。', desp2:'开始签到时间未到不能签到，到了开始签到时间可以签到，上班考勤时间可以在上班弹性延迟时长范围内可以弹性延迟，超过上班弹性延迟时长范围签到为迟到，下班考勤时间根据上班考勤时间也会弹性延迟，在弹性延迟后的下班考勤时间之前签退为早退，结束签到时间之前可以签退，结束签到时间之后不能签退'},
    {id:3, name:'固定班次自由考勤', desp:'24小时范围内，最多设置1个自由考勤时段，需设置开始签到时间、上班考勤时长、结束签到时间，可以跨天设置时间，时间跨度在24小时内。', desp2:'开始签到时间未到不能签到，到了开始签到时间可以签到，签到不设迟到，签退时如果工时未达到工作时长为早退，结束签到时间之前可以签退，结束签到时间之后不能签退'}
]

const cross=['次日','当天']

class Index extends Component {
    handlePickerTime = e => {
    };

    handleCrossClick=(e)=>{
        e.stopPropagation()
    }

    handleCrossChange=(e,i)=>{
        e.stopPropagation()
        this.props.handlefieldchange(e.target.value,i)
    }

    handleNameClick=(e,i)=>{
        if(e.target.value.trim().length==0){
            this.props.isvalid(false)
        }
        this.props.handlefieldchange(e.target.value.trim(),i)
    }

    handleFieldChange=(v,i)=>{
        this.props.handlefieldchange(v,i)
    }

    render() {
        const { classes, form_value, changenum, accountinfo } = this.props; 

        return (
            <div style={{marginTop:5}}>
                <Typography component='div' variant="h6">
                    {kqmode[form_value.mode].name}
                    {(accountinfo.isVip<=0?<Typography component='span' variant="body2" style={{color:'red'}} >
                        （需要会员资格才能设置该考勤方式）
                    </Typography>:null)}
                </Typography>
                <Typography component='div' variant="body2" style={{marginTop:10}}>
                    设置要求：{kqmode[form_value.mode].desp}
                </Typography>
                {/* <Grid container spacing={4}>
                    <Grid item xs={3}>
                        <Typography component='span' variant="body1">
                            <TextField margin="dense" label="考勤方式" name="mode"  variant="outlined" required select
                                style={{width:'100%'}} value={form_value.mode} SelectProps={{ native: true }}
                                onChange={event => this.handleFieldChange(parseInt(event.target.value), 'mode') }
                            >
                                {kqmode.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                            </TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Box display='flex' alignItems="center" style={{width:'100%',height:'100%'}}>
                            <Tooltip title={kqmode[form_value.mode].desp2}>
                            <Typography component='span' variant='body2'>
                                {kqmode[form_value.mode].desp}
                            </Typography>
                            </Tooltip>
                        </Box>
                    </Grid>
                </Grid> */}
                <Divider style={{marginTop:10, marginBottom:10}} />
                <Grid container spacing={4}>
                    <Grid item xs={2} style={{display:'flex', alignItems:'center'}}>
                        <Typography component='div' variant="subtitle1" style={{color:accountinfo.isVip>0?'#12161b':'#aaaaaa'}} >
                            弹性考勤:
                        </Typography>
                    </Grid>
                    <Grid item xs={10}>
                        <Grid container>
                            <Grid item xs={3}>
                                <MuiPickersUtilsProvider locale={zhCN} utils={DateFnsUtils}>
                                    <Tooltip title='开始签到时间之前无法进行该时段的签到/签退，开始签到时间之后才可以该时段的签到/签退。时间设置跨天时选择次日。'>
                                        <span>
                                            <TimePicker disabled={accountinfo.isVip>0?false:true} autoOk label="开始签到时间" cancelLabel="取消" okLabel="确定" inputVariant="outlined"
                                                margin="dense" ampm={false} style={{ marginRight: 20 }}
                                                InputLabelProps={{ classes: { root: classes.label } }} value={form_value.mode2info.stime1}
                                                onChange={value => this.handleFieldChange(value, 'stime1') }
                                                InputProps={{
                                                    startAdornment: 
                                                        <InputAdornment position="start">
                                                            {/* <Tooltip title='时间设置跨天时选择次日'> */}
                                                                <FormControl size="small">
                                                                    <Select disabled={accountinfo.isVip>0?false:true}  style={{fontSize:14}} value={form_value.mode2info.flag11} autoWidth
                                                                        onChange={event=>this.handleCrossChange(event, 'flag11')}
                                                                        onClick={event=>this.handleCrossClick(event, 'flag11')}
                                                                    >
                                                                        <MenuItem value={1}><span style={{fontSize:14}}>当天</span></MenuItem>
                                                                        <MenuItem value={0}><span style={{fontSize:14, color:'blue'}}>次日</span></MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                            {/* </Tooltip> */}
                                                        </InputAdornment>,
                                                }}
                                            />
                                        </span>
                                    </Tooltip>
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={3}>
                                <MuiPickersUtilsProvider locale={zhCN} utils={DateFnsUtils}>
                                    <Tooltip title='不考虑弹性延迟的情况下正常的上班考勤时间。时间设置跨天时选择次日。'>
                                        <span>
                                            <TimePicker disabled={accountinfo.isVip>0?false:true} autoOk label="上班考勤时间" cancelLabel="取消"  okLabel="确定" inputVariant="outlined"
                                                margin="dense" ampm={false} style={{ marginRight: 20 }}
                                                onChange={value => this.handleFieldChange(value, 'ontime1') }
                                                InputLabelProps={{ classes: { root: classes.label } }} value={form_value.mode2info.ontime1}
                                                InputProps={{
                                                    startAdornment: 
                                                        <InputAdornment position="start">
                                                            {/* <Tooltip title='时间设置跨天时选择次日'> */}
                                                            <FormControl size="small">
                                                                <Select disabled={accountinfo.isVip>0?false:true} style={{fontSize:14}} value={form_value.mode2info.flag12} autoWidth
                                                                    onChange={event=>this.handleCrossChange(event, 'flag12')}
                                                                    onClick={event=>this.handleCrossClick(event, 'flag12')}
                                                                >
                                                                    <MenuItem value={1}><span style={{fontSize:14}}>当天</span></MenuItem>
                                                                    <MenuItem value={0}><span style={{fontSize:14, color:'blue'}}>次日</span></MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                            {/* </Tooltip> */}
                                                        </InputAdornment>,
                                                }}
                                            />
                                        </span>
                                    </Tooltip>
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={3}>
                                <MuiPickersUtilsProvider locale={zhCN} utils={DateFnsUtils}>
                                    <Tooltip title='不考虑弹性延迟的情况下正常的下班考勤时间。时间设置跨天时选择次日。'>
                                        <span>
                                            <TimePicker disabled={accountinfo.isVip>0?false:true} autoOk label="下班考勤时间" cancelLabel="取消"  okLabel="确定" inputVariant="outlined"
                                                margin="dense" ampm={false} style={{ marginRight: 20 }}
                                                onChange={value => this.handleFieldChange(value, 'offtime1') }
                                                InputLabelProps={{ classes: { root: classes.label } }}  value={form_value.mode2info.offtime1}
                                                InputProps={{
                                                    startAdornment: 
                                                        <InputAdornment position="start">
                                                            {/* <Tooltip title='时间设置跨天时选择次日'> */}
                                                            <FormControl size="small">
                                                                <Select disabled={accountinfo.isVip>0?false:true} style={{fontSize:14}} value={form_value.mode2info.flag13} autoWidth
                                                                    onChange={event=>this.handleCrossChange(event, 'flag13')}
                                                                    onClick={event=>this.handleCrossClick(event, 'flag13')}
                                                                >
                                                                    <MenuItem value={1}><span style={{fontSize:14}}>当天</span></MenuItem>
                                                                    <MenuItem value={0}><span style={{fontSize:14, color:'blue'}}>次日</span></MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                            {/* </Tooltip> */}
                                                        </InputAdornment>,
                                                }}                                
                                            />
                                        </span>
                                    </Tooltip>
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={3}>
                                <MuiPickersUtilsProvider locale={zhCN} utils={DateFnsUtils}>
                                    <Tooltip title='结束签到时间之前还可以该时段的签到/签退，结束签到时间之后无法再进行该时段的签到/签退。时间设置跨天时选择次日。'>
                                        <span>
                                            <TimePicker disabled={accountinfo.isVip>0?false:true} autoOk label="结束签到时间" cancelLabel="取消"  okLabel="确定" inputVariant="outlined"
                                                ampm={false} margin="dense" style={{ marginRight: 20 }}
                                                InputLabelProps={{ classes: { root: classes.label } }} value={form_value.mode2info.etime1}
                                                onChange={value => this.handleFieldChange(value, 'etime1') }
                                                InputProps={{
                                                    startAdornment: 
                                                        <InputAdornment position="start">
                                                            {/* <Tooltip title='时间设置跨天时选择次日'> */}
                                                            <FormControl size="small">
                                                                <Select disabled={accountinfo.isVip>0?false:true} style={{fontSize:14}} value={form_value.mode2info.flag14} autoWidth
                                                                    onChange={event=>this.handleCrossChange(event, 'flag14')}
                                                                    onClick={event=>this.handleCrossClick(event, 'flag14')}
                                                                >
                                                                    <MenuItem value={1}><span style={{fontSize:14}}>当天</span></MenuItem>
                                                                    <MenuItem value={0}><span style={{fontSize:14, color:'blue'}}>次日</span></MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                            {/* </Tooltip> */}
                                                        </InputAdornment>,
                                                }}
                                            />
                                        </span>
                                    </Tooltip>
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={3} style={{display:'flex', alignItems:'center'}}>                 
                                <Typography component='span' variant="body2" style={{color:accountinfo.isVip>0?'#12161b':'#aaaaaa'}} >
                                    上班时间最多可以弹性延迟至：
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <MuiPickersUtilsProvider locale={zhCN} utils={DateFnsUtils}>
                                    <Tooltip title='最晚上班考勤时间之后签到属于迟到。时间设置跨天时选择次日'>
                                        <span>
                                            <TimePicker disabled={accountinfo.isVip>0?false:true} autoOk label="最晚上班考勤时间" cancelLabel="取消" okLabel="确定" inputVariant="outlined"
                                                margin="dense" ampm={false} style={{ marginRight: 20}}
                                                InputLabelProps={{ classes: { root: classes.label } }} value={form_value.mode2info.dontime1}
                                                onChange={value => this.handleFieldChange(value, 'dontime1') }
                                                InputProps={{
                                                    startAdornment: 
                                                        <InputAdornment position="start">
                                                            {/* <Tooltip title='时间设置跨天时选择次日'> */}
                                                                <FormControl size="small">
                                                                    <Select disabled={accountinfo.isVip>0?false:true}  style={{fontSize:14}} value={form_value.mode2info.dflag12} autoWidth
                                                                        onChange={event=>this.handleCrossChange(event, 'dflag12')}
                                                                        onClick={event=>this.handleCrossClick(event, 'dflag12')}
                                                                    >
                                                                        <MenuItem value={1}><span style={{fontSize:14}}>当天</span></MenuItem>
                                                                        <MenuItem value={0}><span style={{fontSize:14, color:'blue'}}>次日</span></MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                            {/* </Tooltip> */}
                                                        </InputAdornment>,
                                                }}
                                            />
                                        </span>
                                    </Tooltip>
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={6} style={{display:'flex', alignItems:'center'}}>                 
                                <Typography component='span' variant="body2" style={{color:accountinfo.isVip>0?'#12161b':'#aaaaaa'}} >
                                    上班考勤时间弹性延迟后，下班考勤时间根据上班考勤弹性延迟的时长相应地也会弹性延迟。
                                </Typography>
                            </Grid>
                        </Grid>                        
                    </Grid>
                </Grid>
                {/* <Divider style={{marginTop:5, marginBottom:10}} />              
                <Typography component='div' variant="body2" style={{marginTop:10}}>
                    注意事项：{kqmode[form_value.mode].desp2}
                </Typography> */}
            </div>
        );
    }
}
Index.propTypes = {
    changenum: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    form_value: PropTypes.object.isRequired,
    handlefieldchange: PropTypes.func.isRequired,
    accountinfo: PropTypes.object.isRequired
    // num: PropTypes.number.isRequired,
    // isvalid: PropTypes.func.isRequired
};
export default withStyles(styles)(Index);
